const messages = {
  "update-application-message": "We have enhanced the app to serve you better. Please download the latest version of Application.",
  "invalid-access": "Service Unavailable. Please try later.",
  "1003": "Invalid username or password. Please try again.",
  "1061": "Invalid token.",
  "1067": "Forbidden External Access.",
  "1069": "Login account blocked.",
  "1070": "Your account is locked. Please contact your Relationship Manager.",
  "1071": "User expired",
  "5001": "System error",
  "error-encryption-phonline": "Unable to connect. Please try again later.",
  "401": "Authorisation Failed. Please access the application only from the bank's internal network.",
  "error-pwd-update": "Problem in updating your password",
  "1051": "The new password is one of the previous five.",
  "1050": "Invalid password",
  "1053": "Password must have 1 special char out of [$@#/^*] and a number [0-9] / Passwort muss ein Sonderzeichen [$@#/^*] und eine Zahl [0-9] enthalten"
};
const SEPERATOR = '#@#';
module.exports = {messages,SEPERATOR};
